/**
 * @generated SignedSource<<af4dd5cab78570395df5268f6d43053f>>
 * @relayHash 00183e3794ce9ff0eeb9c761070bca7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa25187ac4c98f9510c7a5764fa8e1a4dc35ff0593f08df4bfb2db3c1f72711c

import type { ConcreteRequest } from 'relay-runtime';
export type agentMenuVerificationDropdownItemQuery_activationQuery$variables = {
  cloudId: string;
  product: string;
  skip: boolean;
};
export type agentMenuVerificationDropdownItemQuery_activationQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type agentMenuVerificationDropdownItemQuery_activationQuery = {
  response: agentMenuVerificationDropdownItemQuery_activationQuery$data;
  variables: agentMenuVerificationDropdownItemQuery_activationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "cloudIds.0",
                "variableName": "cloudId"
              }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
          }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "product",
                "variableName": "product"
              }
            ],
            "concreteType": "TenantContextActivationId",
            "kind": "LinkedField",
            "name": "activationIdByProduct",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "active"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "agentMenuVerificationDropdownItemQuery_activationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentMenuVerificationDropdownItemQuery_activationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "fa25187ac4c98f9510c7a5764fa8e1a4dc35ff0593f08df4bfb2db3c1f72711c",
    "metadata": {},
    "name": "agentMenuVerificationDropdownItemQuery_activationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fc36e73c50318e24e1dbbb48c3d00068";

export default node;
